import React, { useMemo, useState } from "react";
import CollapsibleSection from "../CollapsibleSection";
import SectionSearch from "./SectionSearch";
import { filterOptions } from "./filterOptionUtils";
import styles from "../ViewOptionsPanel.module.scss";

const sameId = (a, b) => String(a ?? "") === String(b ?? "");

const ChipMultiSection = ({
  title,
  selectedIds = [],
  options = [],
  onChange,
  showAllOption = true,
  allLabel = "Tümü",
  defaultOpen = true,
  searchPlaceholder = "Ara...",
}) => {
  const [query, setQuery] = useState("");

  const visibleOptions = useMemo(
    () => filterOptions(options, query),
    [options, query],
  );

  const toggle = (id) => {
    if (!onChange) return;
    if (id === null) {
      onChange([]);
      return;
    }
    const has = selectedIds.some((x) => sameId(x, id));
    onChange(
      has
        ? selectedIds.filter((x) => !sameId(x, id))
        : [...selectedIds, String(id)],
    );
  };

  return (
    <CollapsibleSection title={title} defaultOpen={defaultOpen}>
      <div className={styles.filterSectionBody}>
        {options.length > 0 && (
          <SectionSearch
            value={query}
            onChange={setQuery}
            placeholder={searchPlaceholder}
            ariaLabel={`${title} ara`}
          />
        )}
        <div
          className={`${styles.chipGrid} ${styles.filterScrollList}`}
          role="group"
          aria-label={title}
        >
          {showAllOption && (
            <button
              type="button"
              className={`${styles.chip} ${selectedIds.length === 0 ? styles.chipActive : ""}`}
              aria-pressed={selectedIds.length === 0}
              onClick={() => toggle(null)}
            >
              {allLabel}
            </button>
          )}
          {visibleOptions.map((opt) => {
            const active = selectedIds.some((id) => sameId(id, opt.value));
            return (
              <button
                key={String(opt.value)}
                type="button"
                className={`${styles.chip} ${active ? styles.chipActive : ""}`}
                aria-pressed={active}
                onClick={() => toggle(opt.value)}
              >
                {opt.label}
              </button>
            );
          })}
        </div>
        {query.trim() && visibleOptions.length === 0 && (
          <div className={styles.pickerHint}>Sonuç bulunamadı</div>
        )}
      </div>
    </CollapsibleSection>
  );
};

export default ChipMultiSection;
